export default "__VITE_ASSET__B4XYzzM$__"